import PropTypes from 'prop-types';

export default function ArticleActions({ children }) {
  return <div className="article-actions">{children}</div>;
}

ArticleActions.propTypes = {
  children: PropTypes.node.isRequired,
};
